/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */

const clientId = window.REACT_APP_CLIENTID
export const msalConfig = {
    auth: {
        clientId: clientId,
        authority: window.REACT_APP_AUTHORITY,
        redirectUri: "/signuplist/", // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
        postLogoutRedirectUri: "/", // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: true, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    //Console statements for each level for troubleshooting, you can always uncomment them if needed
                    case LogLevel.Error:
                       // console.error(message);
                        return;
                    case LogLevel.Info:
                       // console.info(message);
                        return;
                    case LogLevel.Verbose:
                      //  console.debug(message);
                        return;
                    case LogLevel.Warning:
                      //  console.warn(message);
                        return;
                }
            }
        }
    }
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
    apiTodoList: {
        todoListEndpoint: window.REACT_APP_APIENDPOINT+"/api/v2/support/trial",
        validateEndpoint: window.REACT_APP_APIENDPOINT+"/api/v2/support/trial/activate",
        markEndpoint: window.REACT_APP_APIENDPOINT+"/api/v2/support/trial/mark",
        extendEndpoint: window.REACT_APP_APIENDPOINT+"/api/v2/support/trial/extend",
        blockEndpoint: window.REACT_APP_APIENDPOINT+"/api/v2/support/trial/block",
        endTrialEndpoint: window.REACT_APP_APIENDPOINT+"/api/v2/support/trial/end",
        addLCREndpoint: window.REACT_APP_APIENDPOINT+"/api/v2/support/call_routing",
        signupDetEndpoint: window.REACT_APP_APIENDPOINT+"/api/v2/support",
        timeZonesEndpoint: window.REACT_APP_APIENDPOINT+"/api/v2/auth/time_zone",
        getSignupEndpoint: window.REACT_APP_APIENDPOINT+"/api/v2/support/customer",
        loginaccessEndpoint: window.REACT_APP_APIENDPOINT+"/api/v2/support/user_impersonate",
        pipeAddDealEndpoint: window.REACT_APP_PIPEDRIVEAPI+"/deals?api_token="+window.REACT_APP_PIPEDRIVETOKEN,
        pipeAddLeadEndpoint:window.REACT_APP_PIPEDRIVEAPI+"/leads?api_token="+window.REACT_APP_PIPEDRIVETOKEN,
        pipeSearchPersonEndpoint:window.REACT_APP_PIPEDRIVEAPI+"/persons/search?api_token="+window.REACT_APP_PIPEDRIVETOKEN,
        pipeGetDealEndpoint:window.REACT_APP_PIPEDRIVEAPI+"/deals/search?api_token="+window.REACT_APP_PIPEDRIVETOKEN,
        pipeAddPersonEndpoint:window.REACT_APP_PIPEDRIVEAPI+"/persons?api_token="+window.REACT_APP_PIPEDRIVETOKEN,
        scopes: [window.REACT_APP_APIENDPOINT+"/access_as_user"],
    },
}

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: [...protectedResources.apiTodoList.scopes]
};

export const appRoles = {
    TaskUser: "TaskUser",
    TaskAdmin: "TaskAdmin",
    GlobalView: "Global.View",
    TrialAdmin: "Trial.Admin",
    GlobalAdmin: "Global.Admin",
    SalesMember: "Sales.Member",
    CSMember: "CS.Member"
}
